import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  NgbAlertModule,
  NgbDropdownModule,
  NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import {
  GridWrapperModule,
  TableLayoutModule,
} from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  DateModule,
  DatepickerModule,
  LoaderModule,
  NfFormsModule,
  RadioModule,
} from '@northfork/ng-basics'
import { BulkClearwaterTransactionsPanelComponent } from './bulk-clearwater-transactions-panel.component'
import { BulkClearwaterTransactionsGridComponent } from './components/bulk-clearwater-transactions-grid/bulk-clearwater-transactions-grid.component'
import { FindTransactionsPopoverComponent } from './components/find-transactions-popover/find-transactions-popover.component'
import { UploadTransactionsFileComponent } from './components/upload-transactions-file/upload-transactions-file.component'
import { BulkClearwaterTransactionsService } from './services/bulk-clearwater-transactions.service'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    NgbPopoverModule,
    GridWrapperModule,
    LoaderModule,
    ButtonModule,
    NfFormsModule,
    FormsModule,
    ReactiveFormsModule,
    RadioModule,
    DateModule,
    DatepickerModule,
    NgbDropdownModule,
    NgSelectModule,
    NgbAlertModule,
  ],
  declarations: [
    BulkClearwaterTransactionsPanelComponent,
    BulkClearwaterTransactionsGridComponent,
    FindTransactionsPopoverComponent,
    UploadTransactionsFileComponent,
  ],
  providers: [BulkClearwaterTransactionsService],
  exports: [BulkClearwaterTransactionsPanelComponent],
})
export class BulkClearwaterTransactionsModule {}

export { BulkClearwaterTransactionsPanelComponent }
